import './StyleGuide.css';
import color1 from './color1.png'
import color3 from './color3.png'
import color4 from './color4.png'
import color9 from './color9.png'
import color8 from './color8.png'

import React from 'react'

function ColorGuide() {
  return (
    <div id="elements">
        <h2 className="style_header">Colors</h2>
        <div className='colors'> 
            <p className='medium'>The colors of our application create a radiant mood. We use a combination of greens, white, dark blue, and black.</p>
            <p className='medium'>Colors for margins and main page backgrounds should either be green [#02c487] or follow the gradient pattern: rgba(46,204,113,1) 0%, rgba(26,188,156,1) 52%, rgba(22,160,133,1) 100%</p>
            <p className='medium'>A dark blue [#053c5e] is used in text in our main page and application, like description, posts, logos, and labels. It is also commonly used as a background for white text that seeks to draw attention.</p>
            <p className='medium'> The darker greens [#2d6a4f] are also used when hovering over buttons or
            lighter greens [#d9f8ee] hovering over tabs on the sidebar. See examples in the layout guide below.</p>

        <div className='medium'> Main Color Palette (in order): #2d6a4f, rgba(46,204,113,1), #1abc9c, #d9f8ee, #053c5e </div>
            <div className='color_align'> 
                <img className="palette" src={color1}></img>
                <img className="palette" src={color3}></img>
                <img className="palette" src={color4}></img>
                <img className="palette" src={color9}></img>
                <img className="palette" src={color8}></img>
            </div>
        </div>
    </div>
  )
}

export default ColorGuide